export function combineClasses(
  ...classes: (Array<string | undefined | null> | string | undefined | null)[]
): string {
  return classes
    .map((c) => {
      if (Array.isArray(c)) return combineClasses(...c);
      return c;
    })
    .filter((c) => c)
    .join(" ");
}
